import * as React from 'react';

import classNames from 'classnames';

import { getFiledUrl } from '@utils';

import { Pic } from '@components';

import { ScrollCarousel } from '@ui';

import { IScreenshot, IScreenshotCarouselProps } from './types';

import * as s from './ScreenshotCarousel.scss';

export const ScreenshotCarousel = (props: IScreenshotCarouselProps) => {
	const {
		screenshots,
		className,
		isFake,
	} = props;
	const width = 164;

	if (!screenshots.length) {
		return null;
	}

	return <ScrollCarousel className={classNames(className, s.block)} classNameSlides={s.slide}>
		{screenshots.map((screenshot: IScreenshot) =>
			<div key={screenshot.pic}>
				<div className={s.imageWrapper}>
					<Pic
						className={s.image}
						src={!isFake && getFiledUrl(screenshot.pic, { width, isCropped: true })}
						srcSet={!isFake && `${getFiledUrl(screenshot.pic, { width: width * 2, isCropped: true })} 2x`}
						alt={screenshot.alt}
					/>
				</div>
			</div>)}
	</ScrollCarousel>;
};
